import $ from 'jquery';

function initSlickHome(elem) {
    elem.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<i class="material-icons">chevron_left</i>',
        nextArrow: '<i class="material-icons">chevron_right</i>',
        responsive: [
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });
}

function initSlickManufacturers(elem) {
  elem.slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<i class="material-icons slick-arrow">chevron_left</i>',
  nextArrow: '<i class="material-icons slick-arrow">chevron_right</i>',
  responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

$(document).ready(function () {
    
    // slider in bootstrap tabs Novedades / Destacados 
    $('.tabs-products-home a[data-toggle="tab"]').on('shown.bs.tab', function() {
        initSlickHome($($(this).attr('href')).find('.products'));
    }).first().trigger('shown.bs.tab');

   
    
    initSlickManufacturers($('#foo_bar'));
});


// WEBPACK FOOTER //
// ./js/home.js